import styled from 'styled-components';
import { Button } from 'antd';
import { lighten, darken, transparentize } from 'polished';
import {BLACK, BLACK_300, GREY, GREY_1, BLACK_400, WHITE, LIGHT_PRIMARY, PRIMARY, RED} from "../../utils/colors";
import {StyledText} from "../CustomAntdComponents/Typography";

export const Wrapper = styled.div`
  padding-top: 5px;
  
  .ant-select {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: right;
  
  .ant-btn {
    padding-left: 50px;
    padding-right: 50px;
  }
`;

export const CollapseWrapper = styled.div`
  .ant-collapse-expand-icon {
    svg {
      path {
        fill: ${BLACK};
      }
    }
  }

  .ant-collapse-content, .ant-collapse {
    border: none;
    background: none;
  }
  .ant-collapse > .ant-collapse-item {
    border: none;
    background: none;
  }
  
  .ant-collapse-content-box {
    padding-top: 15px;
    padding-left: 0;
  }
  
  .ant-collapse-header-text {
    font-weight: 700;
    font-size: 16px;
    color: ${GREY};
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    align-items: center;
    padding-left: 0;
  }
`;


export const ContactFormWrapper = styled.div`
  .ant-form-item-control {
    width: 100% !important;
  }
  
  @media (max-width: 991px) {
    .ant-form-item-label > label  {
      height: 22px;
    }
  }
`;

export const CheckBoxLabel = styled(StyledText)`
  font-size: 15px;
  color: ${BLACK_300};
`;


export const InfoWrapper = styled.div`
  margin-bottom: 25px;
    .ant-typography {
      color: ${BLACK_300};
    }
`;

export const PrefillSectionWrapper = styled.div<{ $selected?: boolean }>`
  background: ${({ $selected }) => $selected ? 'transparent' : LIGHT_PRIMARY};
  padding: ${({ $selected }) => $selected ? '0' : '20px'};
  border-radius: 16px;
  margin-bottom: 20px;

  &.has-error {
    background: ${transparentize(0.88, RED)};
  }
`;

export const PrefillHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  
  h4 {
    margin: 0;
    font-size: 16px;

    &.has-error {
      color: ${RED};
    }
  }

  .has-error path {
    fill: ${RED} !important;
  }
`;

export const PrefillActions = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
`;

export const StyledSavedProfileButton = styled(Button)`
  border: 1px solid ${GREY_1};
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${BLACK_400};
  font-weight: 500;
  border-radius: 100px;
`;

export const StyledUploadButton = styled(Button)`
  border: solid 0px transparent !important;
  border-radius: 100px;
  position: relative;
  color: ${BLACK_400};
  font-weight: 500;
  background: white !important;
  box-shadow: 0 0 2px 1px ${transparentize(0.65, PRIMARY)} !important;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 118px;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    padding: 1.5px;
    border-radius: inherit;

    background: linear-gradient(
      180deg,
      ${lighten(0.1, PRIMARY)} -11.76%,
      ${PRIMARY} 44.12%,
      ${darken(0.05, PRIMARY)} 100%
    );

    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);

    -webkit-mask-composite: xor;
    mask-composite: exclude;

    pointer-events: none;
    z-index: 0;
  }
`;

export const ProfileMenuItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 4px;
`;

export const ProfileAvatar = styled.div<{ $bg?: string; $color?: string }>`
  background: ${({ $bg }) => $bg || '#FFF5E6'};
  color: ${({ $color }) => $color || '#EC9832'};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProfileName = styled.div`
  font-weight: 600;
  color: ${BLACK_400};
  
  span {
    color: ${GREY};
    font-weight: normal;
  }
`;

export const ProfileDetails = styled.div`
  color: ${GREY};
  font-size: 12px;
  margin-top: 4px;
`;

export const SelectedProfileCard = styled.div`
  border: 1px solid ${GREY_1};
  padding: 16px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
